export default "__VITE_ASSET__CZh5UwJw__"